import { Outlet } from 'react-router-dom'

import { BenefitsRootPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useQuery } from 'modules/core/hooks/useQuery'

import CollectionsBootstrap from 'modules/benefits/lib/CollectionsBootstrap'
import PageLoading from 'modules/layout/components/Page/Loading'

const Container = () => {
  const { data } = useQuery(BenefitsRootPageDocument)

  const canSeeBenefits = data?.benefits._policies.sidebarSeeBenefitsTopLevelItem.can

  return (
    <AuthorizeUser authorizeFn={() => canSeeBenefits ?? true}>
      {canSeeBenefits ? <Outlet /> : <PageLoading />}
    </AuthorizeUser>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
